import { MigraineIcon, HeadacheIcon, BrainfogIcon, FreeIcon } from './DiaryIcons'

// ── Types ────────────────────────────────────────────────────────────

type DbSymptom = 'migraine' | 'headache' | 'brainfog' | 'no-symptoms'

interface SymptomDef {
  dbValue: DbSymptom
  Icon: React.ComponentType<{ size?: number; color?: string }>
  bg: string
  color: string
  dotClass: string
}

export type SymptomKey = keyof typeof SYMPTOM_CONFIG
export type SymptomStats = Record<SymptomKey, number>

// ── Config ───────────────────────────────────────────────────────────
// Rename keys freely — the dbValue handles API conversion.

const SYMPTOM_CONFIG = {
  migraine: { dbValue: 'migraine', Icon: MigraineIcon, bg: 'var(--cat-migraine-bg)', color: 'var(--cat-migraine)', dotClass: 'bg-[var(--cat-migraine)]' },
  headache: { dbValue: 'headache', Icon: HeadacheIcon, bg: 'var(--cat-headache-bg)', color: 'var(--cat-headache)', dotClass: 'bg-[var(--cat-headache)]' },
  brainfog: { dbValue: 'brainfog', Icon: BrainfogIcon, bg: 'var(--cat-brainfog-bg)', color: 'var(--cat-brainfog)', dotClass: 'bg-[var(--cat-brainfog)]' },
  'no-symptoms': { dbValue: 'no-symptoms', Icon: FreeIcon, bg: 'var(--cat-no-symptoms-bg)', color: 'var(--cat-no-symptoms)', dotClass: 'bg-[var(--cat-no-symptoms)]' },
} as const satisfies Record<string, SymptomDef>

// ── Derived (auto-generated from config) ─────────────────────────────

const SYMPTOM_KEYS = Object.keys(SYMPTOM_CONFIG) as SymptomKey[]

const DB_TO_KEY: Record<DbSymptom, SymptomKey> = Object.fromEntries(
  Object.entries(SYMPTOM_CONFIG).map(([key, { dbValue }]) => [dbValue, key])
) as Record<DbSymptom, SymptomKey>

const DEFAULT_SYMPTOM: SymptomKey = DB_TO_KEY['no-symptoms']

function emptyStats(): SymptomStats {
  return Object.fromEntries(SYMPTOM_KEYS.map(k => [k, 0])) as SymptomStats
}

function toDbValue(key: SymptomKey): DbSymptom {
  return SYMPTOM_CONFIG[key].dbValue
}

function fromDbValue(dbVal: string): SymptomKey {
  return DB_TO_KEY[dbVal as DbSymptom] ?? dbVal as SymptomKey
}

export {
  SYMPTOM_CONFIG,
  SYMPTOM_KEYS,
  DEFAULT_SYMPTOM,
  emptyStats,
  toDbValue,
  fromDbValue,
}
